import AWS from 'aws-sdk';


const accessObj = {
    accessKeyId: process.env.GATSBY_S3_ACCESS_KEY,
    secretAccessKey: process.env.GATSBY_S3_SECRET_ACCESS_KEY,
    region: process.env.GATSBY_S3_REGION,
}
AWS.config.update(accessObj);

const s3 = new AWS.S3();
const ssm = new AWS.SSM();

export {
    s3,
    ssm
}